import qs from 'query-string';
import { useLocation, useSearchParams } from 'react-router-dom';

import history from '@/navigation/history';

/**
 * [ Navigate ] query 업데이트
 *  Filters & Search 처럼 query 부분 업데이트 할때 사용함.
 */

export const updateQuery = (newQuery = {}, isReplacable = false) => {
  const currentQuery = qs.parse(location.search);

  history[isReplacable ? 'replace' : 'push']({
    search: qs.stringify({
      ...currentQuery,
      ...newQuery,
    }),
  });
};

const useQuery = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setSearchParams] = useSearchParams();
  const { search, pathname } = useLocation();
  const query = qs.parse(search);

  const clearQuery = () => {
    setSearchParams();
  };

  // 현재 Query에서 key value가 empty인 key 제거
  const removeEmptyKeysFromQuery = () => {
    let updatedQuery = query;

    for (const [key, value] of Object.entries(query)) {
      if (!value?.length) {
        delete updatedQuery[key];
      }
    }

    setSearchParams(updatedQuery);
  };

  return {
    search,
    pathname,
    query, // current query
    updateQuery,
    clearQuery,
    removeEmptyKeysFromQuery,
  };
};

export default useQuery;
